import * as types from "../../mutation-types";

export default {
    [types.SET_CURRENT_USER]: (state, user) => {
        state.currentUserId = (user ? user.id : null)

        //Bugsnag.user = user ? {
        //    id: user.id,
        //    email: user.email,
        //    name: user.name
        //} : {id: 'guest'};
    },

    [types.APP_HYDRATED]: (state) => {
        state.appHydrated = true
    }
}